import React, { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../contexts/AuthContext';
import { LoadingScreen } from '../components/LoadingScreen';
import { ErrorBoundary } from '../components/ErrorBoundary';

export function RootLayout() {
  const location = useLocation();
  const { isAuthLoading, isAuthenticated } = useAuth();

  const pathname = location.pathname;
  const isRootPath = pathname === '/';
  const isOnboardingPath = pathname.startsWith('/onboarding/');
  const isRegisterPath = pathname.startsWith('/register/');
  const isLoginPath = pathname === '/login' || pathname === '/login/code';
  const isForgotPasswordPath = pathname === '/forgot-password';
  const isResetPasswordPath = pathname.startsWith('/reset-password');
  const isLegalPath = pathname.startsWith('/legal/');
  const isUnsubscribePath = pathname === '/unsubscribe';
  const isAuthCallbackPath = pathname === '/auth/callback';

  const isGuestOnlyPath = isRootPath || isOnboardingPath || isRegisterPath || isLoginPath || isForgotPasswordPath || isResetPasswordPath;
  const isPublicPath = isGuestOnlyPath || isLegalPath || isUnsubscribePath || isAuthCallbackPath;

  if (isAuthLoading) {
    return (
      <div className="relative w-full min-h-screen bg-[var(--color-bg)]">
        <div className="max-w-[393px] mx-auto relative min-h-screen bg-[var(--color-bg)] flex items-center justify-center">
          <div className="text-[#6E2726]">Загрузка...</div>
        </div>
      </div>
    );
  }

  if (isAuthenticated && isGuestOnlyPath) {
    return <Navigate to="/home" replace />;
  }

  if (!isAuthenticated && !isPublicPath) {
    return <Navigate to="/login" replace />;
  }

  // Landing page is full-width — skip the mobile container
  if (isRootPath) {
    return (
      <ErrorBoundary>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
    );
  }

  return (
    <div className="relative w-full min-h-screen bg-[var(--color-bg)]">
      {/* Mobile container - iPhone 14 Pro size */}
      <div className="max-w-[393px] mx-auto relative min-h-screen bg-[var(--color-bg)]">
        <ErrorBoundary>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  );
}